import { ianaTimeZoneNameSchema } from "@redotech/redo-common-model/timezone-list";
import {
  TeamCalendarEntrySchema,
  TeamCalendarEntryType,
} from "@redotech/redo-model/team-calendar/team-calendar-entry";
import * as z from "zod";

export const calendarEntry = TeamCalendarEntrySchema;

export const promotionAgendaItemInput = z.object({
  id: z.string().optional(),
  type: z.literal("promotion"),
  details: z.string().trim().min(1),
});

export const marketingCalendarEntryInput = z.object({
  type: z.literal(TeamCalendarEntryType.Marketing).optional(),
  title: z.string().trim().min(1).max(200),
  description: z.string().trim().max(1000).nullish(),
  startAt: z.date(),
  endAt: z.date(),
  timezone: ianaTimeZoneNameSchema,
  allDay: z.boolean(),
  agenda: z.array(promotionAgendaItemInput).default([]),
});

export type CalendarEntry = z.infer<typeof calendarEntry>;
export type MarketingCalendarEntryInput = z.infer<
  typeof marketingCalendarEntryInput
>;
